const JobLinksSchema = {
    "name": {
        "title": "Job Name"
    },
    "url": {
        "title": "Link",
    },
    "IsActive": {
        "title": "Link active",
        "inputType" : "toggle-api"
    }
}

export { JobLinksSchema }